import './styles.less'
import { defaultLocale, defaultColor } from './constants'
import { resourceAssigned } from './parcers'
import ResourceCard from './components/ResourceCard'
import StepsAdvance from './components/StepsAdvance'
import { ChangeOptimalStart } from '../../../domain/jobs/change-optimals/change-optimals-start.component'
import { useGate } from 'statsig-react'
import { TaskNames, TaskState } from '../../../refactory/modules/jobs/domain/task'
import { useTranslation } from 'react-i18next'

const ResourceSteps = ({
  showButton,
  container,
  selectedTask,
  payment,
  confirmPayment,
  resourceInfo,
  assignBtn,
  reAssignBtn,
  steps,
  locale: incLocale,
  primaryColor,
  onClickResource,
  job,
  jobsSearch,
  setSelectedJob,
  timezone
}) => {
  const { t } = useTranslation()
  const isAssigned = resourceAssigned(steps)(resourceInfo)
  const locale = { ...defaultLocale, ...incLocale }
  const color = primaryColor || defaultColor
  const isCreateRoutingV2Active = useGate('is_create_routing_v2_active').value
  const isTasksPickingVerification = selectedTask?.name === TaskNames.PICKING_VERIFICATION
  const isDisabledButton = () => {
    if (isTasksPickingVerification || selectedTask?.status === TaskState.FINISHED) return true

    return false
  }

  return (
    <div className='resource-steps' style={container}>
      {((selectedTask.resources && selectedTask.route && isCreateRoutingV2Active) ||
        !selectedTask.route ||
        !isCreateRoutingV2Active) && (
        <ResourceCard
          payment={payment}
          confirmPayment={confirmPayment}
          disabledButton={isDisabledButton()}
          isAssigned={isAssigned}
          {...resourceInfo}
          callback={isAssigned ? reAssignBtn : assignBtn}
          locale={locale}
          showButton={selectedTask.resources && selectedTask.route && isCreateRoutingV2Active ? false : showButton}
          onClickResource={onClickResource}
          tooltipText={
            isTasksPickingVerification
              ? t('tasks_can_not_assigned', { taskType: t(`tasks-status.${TaskNames.PICKING_VERIFICATION}`) })
              : ''
          }
        />
      )}
      {selectedTask !== undefined && (
        <ChangeOptimalStart
          task={selectedTask}
          job={job}
          jobsSearch={jobsSearch}
          setSelectedJob={setSelectedJob}
          timezone={timezone}
        />
      )}
      {isAssigned ? StepsAdvance(steps)(color)(locale) : null}
    </div>
  )
}

export default ResourceSteps
